<template>
  <div ref="filterBar">
    <ClientOnly>
      <FilterBar
        v-model="filterBarModel"
        :is-multi-select="false"
        :labels="labels"
        :use-singular-term="true"
        @reset="resetFilters"
        @sort="setSortBy"
      />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
const filterBar = ref<HTMLElement>(null)
const componentType = ref('QuickAccess')
const { resetFilters, setSortBy, filterBarModel } = useFilterBar({
  componentType,
  filterBar,
})
const labels = ref({
  audiences: "I'm a",
  topics: "I'm looking for help with",
})
</script>
